import Endpoint from "@/utils/endPoint";
const albumTempListEndpoint = new Endpoint("/albums/templates/teachers/");
const albumTempEndpoint = new Endpoint("/albums/templates/teachers/{tempId}");
const albumTempPageListEndpoint = new Endpoint("/albums/templates/teachers/{tempId}/pages");
const albumTempPageEndpoint = new Endpoint("/albums/templates/teachers/{tempId}/pages/{pageId}");
const albumTempPageRearrangeEndpoint = new Endpoint("/albums/templates/teachers/{tempId}/pages/rearrange");

const deactiveAlbumTempEndpoint = new Endpoint("/albums/templates/teachers/{tempId}/deactivate");
const activateAlbumTempEndpoint = new Endpoint("/albums/templates/teachers/{tempId}/activate");

class AlbumTempService {
    async getAlbumTempListService(params) {
        const result = await albumTempListEndpoint.get(params);
        return result;
    }

    async getAlbumTempService(params) {
        const result = await albumTempEndpoint.get(params);
        return result;
    }

    async createAlbumTempService(params) {
        const result = await albumTempListEndpoint.post(params);
        return result;
    }

    async updateAlbumTempService(params) {
        const { tempId, ...param } = params;
        const result = await albumTempEndpoint.put(param, { tempId });
        return result;
    }

    async updateAlbumTempStatusService(params) {
        const { tempId, is_active = true } = params;
        let result = null;
        if (is_active) {
            result = await deactiveAlbumTempEndpoint.put(null, { tempId });
        } else {
            result = await activateAlbumTempEndpoint.put(null, { tempId });
        }

        return result;
    }

    async updateAlbumTempPageService(params) {
        const { tempId, ...param } = params;
        const result = await albumTempPageListEndpoint.put(param, { tempId });
        return result;
    }

    async getAlbumTempPageInfoService(params) {
        const result = await albumTempPageEndpoint.get(params);
        return result;
    }

    async delAlbumTempPageInfoService(params) {
        const result = await albumTempPageEndpoint.del(null, params);
        return result;
    }

    async rearrangeAlbumTempPageService(params) {
        const { tempId, ...param } = params;
        const result = await albumTempPageRearrangeEndpoint.put(param, { tempId });
        return result;
    }
}

export default new AlbumTempService();
